export class ImageResourceSizeItem
{
	width: number = 0;
	height: number = 0;
	url: string = '';

	clone(): ImageResourceSizeItem
	{
		const clone = new ImageResourceSizeItem();
		clone.width = this.width;
		clone.height = this.height;
		clone.url = this.url;
		return clone;
	}

	static fromJson(json: any): ImageResourceSizeItem | undefined
	{
		if (typeof json === 'object' &&
			typeof json['width'] === 'number' &&
			typeof json['height'] === 'number' &&
			typeof json['url'] === 'string')
		{
			const item = new ImageResourceSizeItem();
			item.width = json['width'];
			item.height = json['height'];
			item.url = json['url'];

			return item;
		}

		return undefined;
	}
}

export class ImageResource
{
	id: string = '';
	sizes: ImageResourceSizeItem[] = [];

	clone(): ImageResource
	{
		const resource = new ImageResource();
		resource.id = this.id;
		resource.sizes = this.sizes.map(item => item.clone());

		return resource;
	}

	isValid(): boolean
	{
		return this.id.length > 0 && this.sizes.length > 0;
	}

	getUrl(): string | undefined
	{
		return this.isValid() ? this.sizes[0].url : undefined;
	}

	static fromJson(json: any): ImageResource
	{
		const resource = new ImageResource();

		if (typeof json === 'object' && json !== null &&
			typeof json['id'] === 'string' &&
			Array.isArray(json['sizes']))
		{
			resource.id = json['id'];

			for (const item of json['sizes'])
			{
				const sizeItem = ImageResourceSizeItem.fromJson(item);

				if (sizeItem !== undefined)
					resource.sizes.push(sizeItem);
			}
		}

		return resource;
	}
}